var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRhombus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 1.3335C7.66654 1.3335 7.33321 1.46016 7.05988 1.72683L1.72654 7.06016C1.19988 7.58016 1.19988 8.42016 1.72654 8.94016L7.05988 14.2735C7.57988 14.8002 8.41988 14.8002 8.93988 14.2735L14.2732 8.94016C14.7999 8.42016 14.7999 7.58016 14.2732 7.06016L8.93988 1.72683C8.66654 1.46016 8.33321 1.3335 7.99988 1.3335ZM7.33321 4.66683L8.66654 4.66683V8.66683H7.33321V4.66683ZM7.33321 10.0002H8.66654V11.3335H7.33321V10.0002Z",
    fill: "#D34528"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRhombus);
export default __webpack_public_path__ + "static/media/alert-rhombus.42e58d835549ddf44a9971181326fbe1.svg";
export { ForwardRef as ReactComponent };